import useAuthHook from '@/hooks/auth'
import { useSearchParams } from 'next/navigation'
import { createContext, FunctionComponent, useContext, useEffect, useState } from 'react'

export interface authContextType {
  isdn?: string
  token?: string
  isWebView: boolean
  isTouchScreen: boolean
  isLoggedIn?: boolean
}

const authContextDefaultValues: authContextType = {
  token: undefined,
  isdn: undefined,
  isWebView: false,
  isTouchScreen: false,
  isLoggedIn: false
}

const AuthContext = createContext<authContextType>(authContextDefaultValues)

export const useAuth = (): authContextType => {
  return useContext(AuthContext)
}

export const AuthProvider: FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
  const { token, isdn, isLoggedIn, handleWebview } = useAuthHook()
  const [isWebView, setWebView] = useState<boolean>(false)
  const [isTouchScreen, setTouchScreen] = useState<boolean>(false)

  const paramToken = useSearchParams().get('t')
  const source = useSearchParams().get('source')

  useEffect(() => {
    if (paramToken !== null && paramToken.trim() !== '' && typeof window !== 'undefined') {
      handleWebview(window.atob(paramToken))
    }
  }, [paramToken])
  useEffect(() => {
    if (source === 'touchscreen') {
      setTouchScreen(true)
    }
  }, [source])

  useEffect(() => {
    const rNwebView = (window as any).ReactNativeWebview
    const flutterWebview = (window as any).mobiBridge
    if (rNwebView !== undefined || flutterWebview !== undefined) {
      setWebView(true)
    }
  }, [])

  return (
    <AuthContext.Provider value={{
      token,
      isdn,
      isWebView,
      isTouchScreen,
      isLoggedIn
    }}
    >
      {children}
    </AuthContext.Provider>
  )
}
